import Axios from 'axios';

import { HttpStatusCodeEnum, ZepQuizApiError } from '@/api/httpClient';

const isApiErrorInErrorCodes = (error: unknown, httpCodes: number[]) => {
  if (error instanceof ZepQuizApiError) {
    return httpCodes.includes(error.httpStatus);
  }

  if (Axios.isAxiosError(error)) {
    return httpCodes.includes(error.response?.status || 200);
  }
};

export const isIgnoreError = (_error: unknown) => {
  if (Axios.isCancel(_error)) {
    return true;
  }

  return isApiErrorInErrorCodes(_error, [
    HttpStatusCodeEnum.UNAUTHORIZED_401,
    HttpStatusCodeEnum.FORBIDDEN_403,
  ]);
};

// 404 에러, 400 에러는 무시
export const isIgnoreRetryError = (_error: unknown) => {
  return isApiErrorInErrorCodes(_error, [
    HttpStatusCodeEnum.UNAUTHORIZED_401,
    HttpStatusCodeEnum.FORBIDDEN_403,
    HttpStatusCodeEnum.BAD_REQUEST_400,
    HttpStatusCodeEnum.NOT_FOUND_404,
    HttpStatusCodeEnum.CONFLICT_409,
    HttpStatusCodeEnum.TOO_MANY_REQUESTS_429,
    HttpStatusCodeEnum.INTERNAL_SERVER_ERROR_500,
  ]);
};

export const LONG_REQUEST_TIMEOUT = 5 * 60 * 1000;
